import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Plus } from "@phosphor-icons/react";

export default function ProductCard({ p }) {
  const { add } = useCart();
  const oos = p.in_stock === false;
  const discount = p.compare_at_price && p.compare_at_price > p.price
    ? Math.round((1 - p.price / p.compare_at_price) * 100) : null;

  return (
    <div className="product-cell relative bg-white flex flex-col group" data-testid={`product-card-${p.id}`}>
      <Link to={`/product/${p.id}`} className="block">
        <div className="aspect-square bg-zinc-100 overflow-hidden flex items-center justify-center relative">
          {p.image ? (
            <img src={p.image} alt={p.title} loading="lazy" className={`product-img w-full h-full object-contain p-6 ${oos ? "opacity-40 grayscale" : ""}`} />
          ) : (
            <div className="text-zinc-400 text-xs uppercase tracking-widest">No Image</div>
          )}
          {oos ? (
            <span className="absolute top-3 left-3 tag bg-zinc-900 text-white border-zinc-900" data-testid={`oos-badge-${p.id}`}>Out of Stock</span>
          ) : discount && (
            <span className="absolute top-3 left-3 tag bg-[#ff3333] text-white border-[#ff3333]">-{discount}%</span>
          )}
        </div>
      </Link>
      <div className="p-4 flex flex-col flex-1 border-t border-zinc-900">
        <div className="text-[0.65rem] uppercase tracking-widest text-zinc-500 font-[Outfit] font-bold mb-1">{p.category || p.product_type || "General"}</div>
        <Link to={`/product/${p.id}`} className="text-sm font-semibold leading-tight hover:underline line-clamp-2 min-h-[2.5rem]">{p.title}</Link>
        <div className="flex items-baseline gap-2 mt-3">
          <span className="text-xl font-black font-[Outfit]">${p.price.toFixed(2)}</span>
          {p.compare_at_price && p.compare_at_price > p.price && (
            <span className="text-xs text-zinc-500 line-through">${p.compare_at_price.toFixed(2)}</span>
          )}
        </div>
        <button
          data-testid={`add-to-cart-${p.id}`}
          onClick={() => add(p)}
          disabled={oos}
          className={`mt-3 btn-brutal w-full text-xs ${oos ? "opacity-40 pointer-events-none" : ""}`}
        >
          {oos ? "Out of Stock" : <><Plus size={14} weight="bold" className="mr-1" /> <span className="hidden sm:inline">Add To Cart</span><span className="sm:hidden">Add</span></>}
        </button>
      </div>
    </div>
  );
}
